/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Where an unscored submission of an evaluatable problem stands (#247).
 * 
 * Judging writes the results and the points in one transaction, so a submission without points
 * has not been judged: `pending` until it is older than `settings.judging_failed_after_seconds`
 * (`backend/db/services/judge/judging_state.py`), `failed` once it is. A judged submission, one
 * of a problem type that is never scored, and any submission read under feedback level none
 * have no state (null).
 * @export
 */
export const JudgingState = {
    Pending: 'pending',
    Failed: 'failed'
} as const;
export type JudgingState = typeof JudgingState[keyof typeof JudgingState];


export function instanceOfJudgingState(value: any): boolean {
    for (const key in JudgingState) {
        if (Object.prototype.hasOwnProperty.call(JudgingState, key)) {
            if (JudgingState[key as keyof typeof JudgingState] === value) {
                return true;
            }
        }
    }
    return false;
}

export function JudgingStateFromJSON(json: any): JudgingState {
    return JudgingStateFromJSONTyped(json, false);
}

export function JudgingStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): JudgingState {
    return json as JudgingState;
}

export function JudgingStateToJSON(value?: JudgingState | null): any {
    return value as any;
}

export function JudgingStateToJSONTyped(value: any, ignoreDiscriminator: boolean): JudgingState {
    return value as JudgingState;
}

